import { useEffect } from "react";
import { useDispatch } from "react-redux";
import * as actions from "../redux/creators";

/**
 * iOS Safari payment loading reset hook
 * 
 * Only resets when user returns from payment gateway.
 * Uses sessionStorage to track navigation state.
 */
export const useSafariPaymentReset = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        const resetLoading = () => {
            dispatch(actions.courseregPostLoadingReset());
            console.log('[Safari Fix] Loading state reset');
        };

        // Track when page is hidden (navigating to payment)
        let wasHidden = false;

        const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                wasHidden = true;
                sessionStorage.setItem('ajivasan_payment_nav', 'true');
                console.log('[Safari Fix] Page hidden - tracking navigation');
            } else if (document.visibilityState === "visible" && wasHidden) {
                // Page visible after being hidden
                const hadNavigated = sessionStorage.getItem('ajivasan_payment_nav');
                const isPaymentPage = window.location.href.includes('payu') ||
                    window.location.href.includes('payment') ||
                    window.location.href.includes('razorpay');

                if (hadNavigated && !isPaymentPage) {
                    console.log('[Safari Fix] Returned from payment - resetting');
                    setTimeout(resetLoading, 300);
                    sessionStorage.removeItem('ajivasan_payment_nav');
                }
                wasHidden = false;
            }
        };

        // iOS back button detection
        const handlePageShow = (event) => {
            if (event.persisted) {
                const hadNavigated = sessionStorage.getItem('ajivasan_payment_nav');
                if (hadNavigated) {
                    console.log('[Safari Fix] Back button from payment - resetting');
                    setTimeout(resetLoading, 100);
                    sessionStorage.removeItem('ajivasan_payment_nav');
                }
            }
        };

        window.addEventListener("pageshow", handlePageShow);
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            window.removeEventListener("pageshow", handlePageShow);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [dispatch]);
};
